import './_breadcrumb.scss';

/*
 * Init Breadcrumb component
 */
export default function Breadcrumb() {
    const $breadcrumb = document.querySelector('#main-wrapper .region-breadcrumb .block-text a') as HTMLDivElement;

    $breadcrumb &&
        $breadcrumb.addEventListener('click', () => {
           
            if (document.referrer && validateReferrer(document.referrer)) {
                window.location.href = document.referrer;             
            } else {
                history.back();
            }
        });
}

function validateReferrer(referrer: string) {
    try {
        const refUrl = new URL (referrer);
        const isSameHost = refUrl.hostname === window.location.hostname 
        const allowedProtocol = ['http:', 'https:'];
        const isAllowedProtocol = allowedProtocol.includes(refUrl.protocol);
        return isSameHost && isAllowedProtocol;         
    } catch (e) {
        return false; 
    }
}
